import React from "react";

import Chips from "../Chips";
import Tooltip from "../Tooltip";
import { IStandardBetProps } from "@/types/GlobalTypes";

//Templates:
/*
  machineGames
{
	StandardBet({
		classes: "sl-green-lighten",

		betType: "1:0.95",
		betLabel: "Random",
		betNum: "Random",
		betGroup: "n50",

		commonProps: this.props
	})
}

  machineGames "disabled" option
{
	StandardBet({
		classes: "sl-green-lighten",

		betType: "1:0.95",
		betLabel: "Random",
		betNum: "Random",
		betGroup: "n50",

		commonProps: this.props,

		disabled: this.props.bets["Order+n50"] > 0
	})
}
*/

/**
 * Same as SlBet but only for UI with table format
 */
export default class StandardBet extends React.Component<IStandardBetProps> {
	render() {
		const {
			betNum, betGroup, betLabel, betType,
			commonProps } = this.props;
		const betKey = betNum + "+" + betGroup;
	
		return (
			<button className={"sl-bet " + this.props.classes}
				key={this.props._key || (commonProps.pcode + "_" + betKey)}
	
				{...{
					bet: betNum,
					group: betGroup,
					pcode: commonProps.pcode
				}}
	
				disabled={this.props.disabled}
	
				onClick={commonProps.insertBet}
			>
	
				<div className="bet-type">{betType}</div>
				<div className="bet-label">{betLabel}</div>
	
				{
					commonProps.bets ?
						<Chips
							mobile={commonProps.mobile}
							betOutOfBounds={commonProps.betOutOfBounds}
							chipBase={commonProps.chipBase}
							bets={commonProps.bets}
							betKey={betKey} />
						: null
				}
	
				{
					commonProps.bets ?
						<Tooltip bet={commonProps.bets[betKey]}
							langStr={commonProps.langdata.language_code}/>
						: null
				}
			</button>
		);
	}
}